import { FormControlLabel, Switch, Typography } from "@mui/material";
import { toStartOfDayISO } from "@root/utils/date/toStartOfDayISO";
import { useI18nContext } from "@root/utils/organisation";
import { addDays } from "date-fns";
import { useModalOfferContext } from "../context";
import { PermanentInputStack, classes } from "./styles";

interface IPermanentInput {
  className?: string;
}

export const PermanentInput = ({ className }: IPermanentInput) => {
  const { offer, setOffer, disabled } = useModalOfferContext();
  const { timeZone } = useI18nContext();

  return (
    <PermanentInputStack className={`${classes.root} ${className}`} gap={3}>
      <FormControlLabel
        className={classes.formControl}
        control={
          <Switch
            id="switch-offer-isPermanent"
            name="switch-offer-isPermanent"
            className={classes.switch}
            size="small"
            checked={offer?.isPermanent || false}
            disabled={disabled}
            onClick={() =>
              setOffer((offer) => {
                if (!offer.isPermanent === false) {
                  offer.expirationDate = toStartOfDayISO(addDays(new Date(), 21), timeZone);
                } else {
                  offer.expirationDate = undefined;
                }
                return {
                  ...offer,
                  isPermanent: !offer?.isPermanent,
                };
              })
            }
          />
        }
        label={
          <Typography
            variant="body1"
            sx={(theme) => ({ color: disabled ? theme.palette.disabled.main : theme.palette.black.main })}
          >
            Offre permanente
          </Typography>
        }
        labelPlacement="start"
      />
    </PermanentInputStack>
  );
};
